// Please note: extraArguments will just be merged to the result object
// Currently, if you want to add relationships, you have to do it manually
// See NewOrder's formDataToRequestFormat for an example
export function defaultFormDataToRequestFormat(
  type,
  unfilteredAttributes,
  attributesWhitelist = [],
  extraArguments = {},
) {
  const attributesList =
    attributesWhitelist || Object.keys(unfilteredAttributes);
  const attributes = attributesList.reduce((accumulator, attribute) => {
    return { ...accumulator, [attribute]: unfilteredAttributes[attribute] };
  }, {});

  return {
    data: { type, attributes, ...extraArguments },
  };
}

export function singleRelationshipToRequestFormat(
  type,
  relationshipType,
  relationshipData,
  extraArguments = {},
) {
  return {
    data: {
      type,
      relationships: {
        [relationshipType]: {
          data: relationshipData.map(record => ({
            id: record.id,
            type: relationshipType,
            attributes: record,
          })),
        },
      },
      ...extraArguments,
    },
  };
}
